module.exports = __webpack_public_path__ + "static/img/guidance4.00681766.webp";